import { Box, Typography } from "@mui/material";
import { nawyTheme } from "@/styles/nawy-theme/nawy-theme";
import { formatSaleInfo, formatSalePrice } from "@/modules/lead-page/components/lead-info/lead-actions/merge-lead/utils/index.ts";

interface SalesSectionProps {
  parentSales?: any[];
  childSales?: any[];
}

const SalesSection = ({ parentSales, childSales }: SalesSectionProps) => {
  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        mt: nawyTheme.nawy.spacing.lg,
      }}
    >
      <Typography
        sx={{
          ...nawyTheme.nawy.typography.english.variants.body.md.semibold,
          color: nawyTheme.nawy.colors.semantic.text.primary,
          mb: nawyTheme.nawy.spacing.sm,
        }}
      >
        Sales
      </Typography>

      <Box
        sx={{
          display: "flex",
          gap: nawyTheme.nawy.spacing.lg,
          width: "100%",
          alignItems: "flex-start",
        }}
      >
        {/* Parent Sales Column */}
        <Box sx={{ flex: 1 }}>
          <Typography
            sx={{
              ...nawyTheme.nawy.typography.english.variants.body.sm.semibold,
              color: nawyTheme.nawy.colors.semantic.text.primary,
              mb: nawyTheme.nawy.spacing.sm,
            }}
          >
            Parent sales
          </Typography>
          
          {parentSales?.map((sale, index) => (
            <Box 
              key={index} 
              sx={{ 
                mb: nawyTheme.nawy.spacing.sm,
                height: "fit-content",
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
              }}
            >
              <Typography
                sx={{
                  ...nawyTheme.nawy.typography.english.variants.body.sm.semibold,
                  color: nawyTheme.nawy.colors.semantic.text.primary,
                  mb: nawyTheme.nawy.spacing.xs,
                  lineHeight: 1.4,
                }}
              >
                {formatSaleInfo(sale)}
              </Typography>
              <Typography
                sx={{
                  ...nawyTheme.nawy.typography.english.variants.body.xs.regular,
                  color: nawyTheme.nawy.colors.semantic.text.secondary,
                }}
              >
                {formatSalePrice(sale?.unitValue || 0)}
              </Typography>
            </Box>
          ))}
          
          {!parentSales?.length && (
            <Typography
              sx={{
                ...nawyTheme.nawy.typography.english.variants.body.sm.regular,
                color: nawyTheme.nawy.colors.semantic.text.tertiary,
                fontStyle: 'italic',
              }}
            >
              No sales
            </Typography>
          )}
        </Box>

        {/* Child Sales Column */}
        <Box sx={{ flex: 1 }}>
          <Typography
            sx={{
              ...nawyTheme.nawy.typography.english.variants.body.sm.semibold,
              color: nawyTheme.nawy.colors.semantic.text.primary,
              mb: nawyTheme.nawy.spacing.sm,
            }}
          >
            Child sales
          </Typography>
          
          {childSales?.map((sale, index) => (
            <Box 
              key={index} 
              sx={{ 
                mb: nawyTheme.nawy.spacing.sm,
                height: "fit-content",
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
              }}
            >
              <Typography
                sx={{
                  ...nawyTheme.nawy.typography.english.variants.body.sm.semibold,
                  color: nawyTheme.nawy.colors.semantic.text.primary,
                  mb: nawyTheme.nawy.spacing.xs,
                  lineHeight: 1.4,
                }}
              >
                {formatSaleInfo(sale)}
              </Typography>
              <Typography
                sx={{
                  ...nawyTheme.nawy.typography.english.variants.body.xs.regular,
                  color: nawyTheme.nawy.colors.semantic.text.secondary,
                }}
              >
                {formatSalePrice(sale?.unitValue || 0)}
              </Typography>
            </Box>
          ))}
          
          {!childSales?.length && (
            <Typography
              sx={{
                ...nawyTheme.nawy.typography.english.variants.body.sm.regular,
                color: nawyTheme.nawy.colors.semantic.text.tertiary,
                fontStyle: 'italic',
              }}
            >
              No sales
            </Typography>
          )}
        </Box>
      </Box>
      <Typography
        sx={{
          ...nawyTheme.nawy.typography.english.variants.body.sm.semibold,
          color: "#F79008",
        }}
      >
        Please note that all child lead sales will be moved to the parent lead once you merge. 
      </Typography>
    </Box>
  );
};

export default SalesSection;
